import { computed, shallowRef } from 'vue'
import { createGlobalState, useAsyncState } from '@vueuse/core'
import { getSimpleDictDataList } from '@/api/config'
import type { GetSimpleDictDataListRes } from '@/types'

const SITE_CURRENCY_KEY = 'PAY:PLATFORM:CURRENCY'
const UPLOAD_SIZE_KEY = 'APP:IMAGE:UPLOAD:SIZE'

/**
 * 全局共享-后台配置字典。
 *
 * 迁移自 H5 useSiteDict；只做全局缓存与字典值派生
 */
export const useSiteDict = createGlobalState(() => {
  const dictList = shallowRef<GetSimpleDictDataListRes[]>([])

  async function fetchSiteDict() {
    if (dictList.value.length > 0) return dictList.value
    const list = await getSimpleDictDataList()
    dictList.value = list
    return list
  }

  const { isLoading, execute: refreshSiteDict } = useAsyncState(fetchSiteDict, [], {
    immediate: true
  })

  const siteCurrency = computed(
    () => dictList.value.find((item) => item.label === SITE_CURRENCY_KEY)?.value ?? ''
  )

  const uploadSizeItem = computed(
    () => dictList.value.find((item) => item.label === UPLOAD_SIZE_KEY)?.value ?? ''
  )

  return {
    dictList,
    // 站点货币单位
    siteCurrency,
    // 上传图片尺寸限制
    uploadSizeItem,
    isLoading,
    refreshSiteDict
  }
})
